<template>
  <v-row>
    <v-col cols="6">
      <v-text-field v-model="data.name" label="Business Name"></v-text-field>
    </v-col>

    <v-col cols="6">
      <v-text-field v-model="data.email" label="Email"></v-text-field>
    </v-col>

    <v-col cols="6">
      <v-text-field v-model="data.website" label="Website"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.address" label="Address"></v-text-field>
    </v-col>

    <v-col cols="6">
      <v-text-field v-model="data.phone" label="Phone"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.mobile" label="Mobile"></v-text-field>
    </v-col>

    <v-col cols="4">
      <v-text-field v-model="data.facebook" label="Facebook"></v-text-field>
    </v-col>
    <v-col cols="4">
      <v-text-field v-model="data.youtube" label="YouTube"></v-text-field>
    </v-col>
    <v-col cols="4">
      <v-text-field v-model="data.instagram" label="Instagram"></v-text-field>
    </v-col>

    <v-col cols="6">
      <select-categories v-model="data.category"></select-categories>
    </v-col>
    <v-col cols="6">
      <select-suburbs
        v-model="data.suburb"
        label="Listing Suburb"
      ></select-suburbs>
    </v-col>
    <v-col cols="6">
      <select-suburbs
        v-model="data.anchor_suburb"
        label="Anchor Suburb"
        placeholder="Used for the 10km radius"
      ></select-suburbs>
    </v-col>

    <v-col cols="12">
      <v-alert dense outlined type="info">
        Priority listings only appear within 10km of the anchor suburb. If you leave it blank, the listing suburb is used.
      </v-alert>
    </v-col>

    <v-col cols="12">
      <v-select
        :items="planOptions"
        item-text="text"
        item-value="value"
        v-model="data.plan"
        label="Plan"
      ></v-select>
    </v-col>

    <v-col cols="6">
      <date-picker label="Start Date" v-model="data.start_date"></date-picker>
    </v-col>
    <v-col cols="6">
      <date-picker label="End Date" v-model="data.end_date"></date-picker>
    </v-col>

    <v-col cols="6">
      <v-switch v-model="data.active" label="Active"></v-switch>
    </v-col>
    <v-col cols="6">
      <v-switch v-model="data.verified" label="Verified"></v-switch>
    </v-col>

    <!-- About -->
    <v-col cols="12">
      <text-editor v-model="data.about"></text-editor>
    </v-col>

    <!-- Services -->
    <v-col cols="12">
      <text-editor v-model="data.services"></text-editor>
    </v-col>

    <!-- Image Upload -->
    <v-col cols="12">
      <v-file-input
        v-model="data.image"
        label="Upload Image"
        accept="image/*"
      ></v-file-input>
    </v-col>
  </v-row>
</template>

<script>
import SelectCategories from '../../../components/SelectCategories'
import SelectSuburbs from '../../../components/SelectSuburbs'
import DatePicker from '../../../components/DatePicker'
import TextEditor from '../../../components/TextEditor'

export default {
  name: 'PriorityListingForm',
  props: ['data'],
  components: {
    DatePicker,
    SelectCategories,
    SelectSuburbs,
    TextEditor
  },

  data() {
    return {
      planOptions: [
        { text: '3 Month', value: '3' },
        { text: '12 Month', value: '12' }
      ]
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style scoped></style>
